export const NUMBER_OF_DAYS_TO_START_GIVE_CLIENTS = 90;
